module.exports = __webpack_public_path__ + "img/t01b3bc142b70ef7e0e.fdd6227f.jpg";